/**
 * /
 * @author libin 2018-05-23 
 * @param  vue 工具类
 * @return 返回一个包含装修模版中公用方法工的对象
 */
import api from "@/config/api.js";
export default {
  install: function (Vue) {
      Vue.prototype.unixTimeTamp = function(time, type) {
        if (time) {
            return new Date(time).getFullYear() + '-' + ((new Date(time).getMonth() + 1) < 10 ? ("0" + (new Date(time).getMonth() + 1)) : ((new Date(time).getMonth()) + 1)) + '-' + ((new Date(time).getDate()) < 10 ? ("0" + (new Date(time).getDate())) : (new Date(time).getDate())) + " " + ((new Date(time).getHours()) < 10 ? ("0" + (new Date(time).getHours())) : (new Date(time).getHours())) + ":" + ((new Date(time).getMinutes()) < 10 ? ("0" + (new Date(time).getMinutes())) : (new Date(time).getMinutes())) + ":" + ((new Date(time).getSeconds()) < 10 ? ("0" + (new Date(time).getSeconds())) : (new Date(time).getSeconds()));
        } else {
            return "";
        }
      };
      Vue.prototype.$reno = {
        filterChannelType(type){
          switch(type){
            case 'all':
              return '全部渠道';
            case 'app':
              return 'App渠道';
            case 'h5':
              return 'H5渠道';
            default:
              return type
          }
        },
      }
      Vue.prototype.formatError = function(){
        $Message.error("不支持的文件类型")
      }
      Vue.prototype.$renoImgApi = api.requestUrl + "decorate/upload/img" //装修模版图片上传路径
      Vue.prototype.$baseCustomUrl = api.frontEndRequestUrl + 'index.html' + "#/act/" //装修自定义页面的前缀地址(测试环境)
      Vue.prototype.$baseSystemUrl = api.frontEndRequestUrl + 'index.html' +  "#/" //装修系统页面的前缀地址(测试环境)
      Vue.prototype.$previewRequestUrl = api.frontEndRequestUrl + '#/preview/'
      Vue.prototype.$goodsUrl = api.frontEndRequestUrl + 'pages/goodsDetails/index?goodsId='

      Vue.prototype.$requestHeaders = function (){
        return {
          userLoginId: window.sessionStorage.getItem('token')
        }
      }
      Vue.filter('filterChannel',function(value){
        switch(value){
          case 'all':
            return '全部渠道';
          case 'app':
            return 'App渠道';
          case 'h5':
            return 'H5渠道';
          default:
            return value
        }
      })
      Vue.filter('filterCouponType',function(value){
        switch(value){
          case 1:
            return '满';
          case 2:
            return '每满';
          default:
            return value
        }
      })
  }
}